import {DiscountAttempt} from '@udemy-v2/api-shopping';

export const DISCOUNT_STATUSES = {
    INVALID: 'invalid',
    EXPIRED: 'expired',
    SOLD_OUT: 'sold_out',
    UNUSED: 'unused',
    APPLIED: 'applied',
    APPLIED_HIDDEN: 'applied_hidden',
};

export const MODES = {
    DISPLAY: 'display',
    INPUT: 'input',
    OFF: 'off',
    PENDING: 'pending',
};

export type ModesKeys = (typeof MODES)[keyof typeof MODES];

export type DiscountStatus = (typeof DISCOUNT_STATUSES)[keyof typeof DISCOUNT_STATUSES];

// TODO: This is a temporary regex pattern for validating discount codes. To be removed once the CouponStore is
// implemented in api-shopping
export const VALID_DISCOUNT_CODE_REGEX = /^([a-zA-Z0-9._-]){4,255}$/;

export const SOURCE_TYPE = {
    GENERAL: 'general',
    UDEMY_COUPON: 'udemy_coupon',
    INSTRUCTOR_COUPON: 'instructor_coupon',
};

// Coupon data interface to match expected API response
export interface CouponData {
    discountAttempts: DiscountAttempt[];
}
